import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollExportItemDTO  {
    _originalTypeClassName = "zERP.BO.PayrollExportItemDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollExportItemDTO.translate = translateService;
}
this.RuleId = null;
this.EmployeeAmount = null;
this.EmployerAmount = null;
this.EmployerParameterValue = null;
this.EmployeeParameterValue = null;
this.BonusIncrease = false;
this.Type = null;
this.PayrollExportItemDTOKey = null;
this._key = this.PayrollExportItemDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
RuleId:any;
EmployeeAmount:any;
EmployerAmount:any;
EmployerParameterValue:any;
EmployeeParameterValue:any;
BonusIncrease:any;
Type:any;
private _PayrollExportItemDTOKey:any;
get PayrollExportItemDTOKey(): any {
    return this._PayrollExportItemDTOKey;
  }
set PayrollExportItemDTOKey(value: any) {
    this._PayrollExportItemDTOKey = value;
    this._key = value;
  }

static ExportContribution(contribution: any): any{let dto = new Domain.PayrollExportItemDTO();
dto.Type = Domain.PayrollExportItemType.Contribution;
dto.RuleId = contribution?.Rule?.Id;
dto.EmployeeAmount = contribution?.EmployeeAmount;
dto.EmployerAmount = contribution?.EmployerAmount;
return dto;
}
static ExportDeduction(deduction: any): any{let dto = new Domain.PayrollExportItemDTO();
dto.Type = Domain.PayrollExportItemType.Deduction;
dto.RuleId = deduction?.Rule?.Id;
dto.EmployeeParameterValue = deduction?.EmployeeParameterValue;
dto.EmployerParameterValue = deduction?.EmployerParameterValue;
dto.EmployeeAmount = deduction?.EmployeeAmount;
dto.EmployerAmount = deduction?.EmployerAmount;
return dto;
}
static ExportSalary(salary: any): any{let dto = new Domain.PayrollExportItemDTO();
dto.Type = Domain.PayrollExportItemType.Salary;
dto.RuleId = salary?.Salary?.Id;
dto.BonusIncrease = salary?.BonusIncrease;
dto.EmployeeAmount = salary?.Amount;
dto.EmployeeParameterValue = salary?.ParameterValue;
return dto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollExportItemDTOKey == null || $this.PayrollExportItemDTOKey == 0;
            }


}